import api from "./Api";

class PedidoItemDetCodBarrasService {
  GetPedidoItemDetCodBarras(payload) {
    return api.get("/v1/pedidoItemDetCodBarras/" + payload).then((response) => {
      return response.data;
    });
  }

  PostPedidoItemDetCodBarras(payload) {
    return api.post("/v1/pedidoItemDetCodBarras/", payload).then((response) => {
      return response.data;
    });
  }

  PutPedidoItemDetCodBarras(payload) {
    return api.put("/v1/pedidoItemDetCodBarras/", payload).then((response) => {
      return response.data;
    });
  }

  DeletePedidoItemDetCodBarras(payload) {
    return api
      .delete("/v1/pedidoItemDetCodBarras/" + payload)
      .then((response) => {
        return response.data;
      });
  }

  GetPedidoItemDetCodBarrasOData(payload) {
    return api
      .get("/OData/PedidoItemDetCodBarras" + payload)
      .then((response) => {
        return response.data;
      });
  }
}

export default new PedidoItemDetCodBarrasService();
